module.exports = __webpack_public_path__ + "d4ed131860cfd86db506b3b04ff216cf.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/dtg-tshirt-black-design-resized.png
// module id = 780
// module chunks = 0